import { render, staticRenderFns } from "./CompetitionSmallDetails.vue?vue&type=template&id=d943df4c&scoped=true"
import script from "./CompetitionSmallDetails.vue?vue&type=script&lang=js"
export * from "./CompetitionSmallDetails.vue?vue&type=script&lang=js"
import style0 from "./CompetitionSmallDetails.vue?vue&type=style&index=0&id=d943df4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d943df4c",
  null
  
)

export default component.exports